import { applyMiddleware,createStore } from 'redux'

import multi from 'redux-multi'
import thunk from 'redux-thunk'

import { Reducers } from './Reducers'

//export default applyMiddleware(thunk,multi,promise)(createStore)(Reducers);
export default applyMiddleware(thunk,multi)(createStore)(Reducers, /* preloadedState, */ window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());